import { useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
import { initPostHog } from '@/lib/posthog';
import { initGlobalErrorHandler } from '@/lib/analytics/errorHandler';

interface PostHogProviderProps {
  children: ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const location = useLocation();

  // Initialize PostHog on mount
  useEffect(() => {
    initPostHog();
    initGlobalErrorHandler();
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const url = window.origin + location.pathname;
      const search = location.search;
      const fullUrl = search ? `${url}${search}` : url;

      posthog.capture('$pageview', {
        $current_url: fullUrl,
      });
    }
  }, [location.pathname, location.search]);

  return <>{children}</>;
}
